// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  npcId: __t.u64().primaryKey().name("npc_id"),
  worldId: __t.u64().name("world_id"),
  owner: __t.identity(),
  name: __t.string(),
  modelKey: __t.string().name("model_key"),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  yaw: __t.f32(),
  scale: __t.f32(),
  scriptSrc: __t.string().name("script_src"),
  enabled: __t.bool(),
  configJson: __t.string().name("config_json"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
